<template>
<div>
    <!-- modal -->
    <b-modal id="lawTradeFairCenterFormModal" centered size="lg" no-close-on-backdrop ref="lawTradeFairCenterFormModal" :title=" $t('lawTradeFairCenter.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="law-trade-fair-center-name-input">{{ $t('lawTradeFairCenter.name') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('lawTradeFairCenter.name')" rules="required">
                                <b-form-input id="law-trade-fair-center-name-input" v-model="name" size="sm" maxlength="100" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="law-trade-fair-center-city-input">{{ $t('lawTradeFairCenter.city') }}</label>
                        <b-form-group>
                            <b-form-select id="law-trade-fair-center-city-input" size="sm" v-model="citySelect" value-field="id" text-field="name" :options="cityOption" @change="getDistrictList()" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="law-trade-fair-center-district-input">{{ $t('lawTradeFairCenter.district') }}</label>
                        <b-form-group>
                            <b-form-select id="law-trade-fair-center-district-input" size="sm" v-model="districtSelect" value-field="id" text-field="name" :options="districtOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="law-trade-fair-center-address-input">{{ $t('lawTradeFairCenter.address') }}</label>
                        <b-form-group>
                            <b-form-input id="law-trade-fair-center-address-input" v-model="address" size="sm" maxlength="250" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="law-trade-fair-center-phone-input">{{ $t('lawTradeFairCenter.phone') }}</label>
                        <b-form-group>
                            <b-form-input id="law-trade-fair-center-phone-input" v-model="phone" size="sm" maxlength="50" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <label for="law-trade-fair-center-note-input">{{ $t('lawTradeFairCenter.note') }}</label>
                    <b-form-textarea id="law-trade-fair-center-note-input" :placeholder=" $t('lawTradeFairCenter.note')" rows="3" v-model="note" maxlength="250" />
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawTradeFairCenterList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            name: '',
            citySelect: 0,
            cityOption: [],
            districtSelect: 0,
            districtOption: [],
            districtList: null,
            address: '',
            phone: '',
            note: '',
        }
    },
    methods: {
        async showInfo(id) {
            this.$refs['lawTradeFairCenterFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawTradeFairCenter'
            }
            const payload = {
                data: data,
                controller: controller
            }
            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.name = response.data.lawTradeFairCenter.name
                    this.address = response.data.lawTradeFairCenter.address
                    this.phone = response.data.lawTradeFairCenter.phone
                    this.note = response.data.lawTradeFairCenter.note

                    this.cityOption = response.data.cityList
                    if (this.cityOption != null) {
                        this.cityOption.splice(0, 0, this.$nullSelected())
                    }
                    this.citySelect = response.data.lawTradeFairCenter.cityId

                    this.districtList = response.data.districtList
                    this.districtOption = []
                    this.districtSelect = 0
                    if (response.data.lawTradeFairCenter.cityId != 0) {
                        this.districtOption = this.districtList.filter(p => p.cityId == response.data.lawTradeFairCenter.cityId)
                        this.districtSelect = response.data.lawTradeFairCenter.districtId
                        this.districtOption.splice(0, 0, this.$nullSelected())
                    }
                } else {
                    this.$bvModal.hide('lawTradeFairCenterFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
        },
        async addOrUpdate() {
            const data = {
                id: this.id,
                name: this.name,
                cityId: this.citySelect,
                districtId: this.districtSelect,
                address: this.address,
                phone: this.phone,
                note: this.note,
            }
            const controller = {
                name: 'LawTradeFairCenter'
            }
            const payload = {
                data: data,
                controller: controller
            }
            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    const response = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawTradeFairCenterFormModal')
                            this.getLawTradeFairCenterList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                }
        },
        getDistrictList() {
            if (this.citySelect > 0) {
                this.districtOption = this.districtList.filter(p => p.cityId == this.citySelect)
                this.districtSelect = 0
                this.districtOption.splice(0, 0, this.$nullSelected())
            }
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
